import { ISeedState } from './seed.types'

export const SeedState: ISeedState = {
  byBusinessId: {},
  activeBusinessId: null
}
